import { atom } from 'jotai/index';

export const userInputCurrentlyEmployeesAtom = atom<{ id: string; name: string; birthday: string }[]>([]);
